if (!customElements.get('product-price-row')) {
  class ProductPriceRow extends HTMLElement {
    connectedCallback() {
      this.priceDetails = this.querySelector('.product-price__details');
      if (!this.priceDetails) return;

      this.resizeObserver = new ResizeObserver(() => this.updateLayout());
      this.resizeObserver.observe(this);
      this.resizeObserver.observe(this.priceDetails);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateLayout() {
      const milesBox = this.querySelector('.product-miles-and-more');
      const milesWrapped = milesBox
        && milesBox.getBoundingClientRect().top >= this.priceDetails.getBoundingClientRect().bottom;

      this.classList.toggle('product-price__row--miles-wrapped', Boolean(milesWrapped));
    }
  }

  customElements.define('product-price-row', ProductPriceRow);
}
